import { gql } from '@apollo/client';

/**
 * A leaf both pages and utils can import. $piezoArtifacts must stay declared: piezoLink injects it, and an
 * undeclared variable is dropped, sending a migrated tool to the proxy unsigned.
 */
export const EXECUTE_INSTANCE_COMMAND = gql`
  mutation ExecuteInstanceCommand(
    $url: String!
    $args: JSON
    $approval: JSON
    $confirm: JSON
    $piezoArtifacts: JSON
  ) {
    executeCommand(
      url: $url
      args: $args
      approval: $approval
      confirm: $confirm
      piezoArtifacts: $piezoArtifacts
    )
  }
`;
